import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'camelCase',
})
export class CamelCasePipe implements PipeTransform {

    constructor() { }

    transform(val: string) {
        return val && val.length > 1
            ? val.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
                return index === 0 ? word.toLowerCase() : word.toUpperCase();
            }).replace(/\s+/g, "")
            : val;
    }

}
